import { render } from "./DownloadAppPage.vue?vue&type=template&id=088aad2f&scoped=true"
import script from "./DownloadAppPage.vue?vue&type=script&lang=js"
export * from "./DownloadAppPage.vue?vue&type=script&lang=js"

import "./DownloadAppPage.vue?vue&type=style&index=0&id=088aad2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088aad2f"]])

export default __exports__